import { CorporateModule } from './module.types';

export const corporateModules: CorporateModule[] = [
  {
    id: 'governance',
    name: 'Governança',
    description: 'Políticas, controles, riscos, conformidade e decisões corporativas.',
    icon: 'GOV',
    route: '/governance',
    status: 'development',
  },
  {
    id: 'iam',
    name: 'IAM',
    description: 'Identidades, organizações, grupos, perfis e controles de acesso.',
    icon: 'IAM',
    route: '/iam',
    status: 'active',
  },
  {
    id: 'catalog',
    name: 'Catálogo',
    description: 'Ativos, sistemas, componentes, APIs e responsabilidades técnicas.',
    icon: 'CAT',
    route: '/catalog',
    status: 'active',
  },
  {
    id: 'projects',
    name: 'Projetos',
    description: 'Portfólio, iniciativas, entregas, marcos e acompanhamento executivo.',
    icon: 'PRJ',
    route: '/projects',
    status: 'development',
  },
  {
    id: 'operations',
    name: 'Operações',
    description: 'Processos, ativos operacionais, eventos e acompanhamento remoto.',
    icon: 'OPS',
    route: '/operations',
    status: 'development',
  },
  {
    id: 'monitoring',
    name: 'Monitoramento',
    description: 'Disponibilidade, telemetria, alarmes, indicadores e observabilidade.',
    icon: 'MON',
    route: '/monitoring',
    status: 'development',
  },
  {
    id: 'documentation',
    name: 'Documentação',
    description: 'Conhecimento corporativo, procedimentos, padrões e documentação técnica.',
    icon: 'DOC',
    route: '/documentation',
    status: 'development',
  },
  {
    id: 'automation',
    name: 'Automação',
    description: 'Fluxos, integrações, rotinas e orquestração de processos.',
    icon: 'AUT',
    route: '/automation',
    status: 'development',
  },
  {
    id: 'analytics',
    name: 'Analytics',
    description: 'Análises, indicadores, relatórios e inteligência corporativa.',
    icon: 'ANL',
    route: '/analytics',
    status: 'development',
  },
  {
    id: 'admin',
    name: 'Administração',
    description: 'Configurações, parâmetros e recursos administrativos da plataforma.',
    icon: 'ADM',
    route: '/admin',
    status: 'development',
  },
];
